<script setup lang="ts">
import type { IconDefinition } from '@fortawesome/fontawesome-common-types'

defineOptions({
  inheritAttrs: false,
})

defineProps<{
  label?: string
  disabled?: boolean
  icon?: IconDefinition
}>()

const model = defineModel<boolean>({ default: false })

const id = useId()
</script>

<template>
  <label :for="id" :disabled="disabled" class="flex items-center w-full justify-between cursor-pointer py-2xs px-s has-[:disabled]:cursor-not-allowed has-[:disabled]:opacity-50">
    <span class="flex items-center gap-2xs text-small">
      <Icon v-if="icon" :icon="icon" />
      <slot name="label">{{ label }}</slot>
    </span>
    <input v-bind="$attrs" :id="id" v-model="model" type="checkbox" :disabled="disabled" :class="checkboxVariants.input()">
  </label>
</template>
